<template>
  <div class="row mt-4">
    <div class="col-md-6 border-right mb-3">
      <h5>Roles Disponibles</h5>
      <div class="d-flex align-items-center justify-content-end">
        <b-form-input
          v-model="searchInVacantRoles"
          class="d-inline-block mr-1"
          placeholder="Filtrar..."
          data-cy="filter-role"
        />
      </div>
    </div>
    <div class="col-md-6 border-right mb-3">
      <h5>Roles Asignados</h5>
    </div>
    <!-- RESULTADOS -->
    <div class="col-md-6 border-right">
      <vs-list class="box-users">
        <div v-for="role in filteredAvailableRoles" :key="role.rolId" data-cy="assigned-roles">
          <vs-list-item
            v-if="role.asignado === 'no'"
            :title="role.nombre"
            v-tooltip="role.descripcion"
          >
            <vs-button
              color="warning"
              size="small"
              type="border"
              v-on:click.once="addRol(role)"
              data-cy="add-permission"
            >
              Agregar
            </vs-button>
          </vs-list-item>
        </div>
        <div v-show="loading">
          <b-skeleton animation="fade" width="70%"/>
          <b-skeleton animation="fade" width="80%"/>
          <b-skeleton animation="fade" width="60%"/>
          <b-skeleton animation="fade" width="85%"/>
          <b-skeleton animation="fade" width="70%"/>
        </div>
      </vs-list>
    </div>
    <div class="col-md-6">
      <vs-list class="box-users">
        <div
         v-for="role in rolesList"
         :key="role.rolId"
         data-cy="remove-permission"
         >
          <vs-list-item
            v-if="role.asignado === 'si'"
            v-tooltip="role.descripcion"
            :title="role.nombre"
          >
            <vs-button
              v-if="!role.nombre.includes('Usuario básico')"
              color="danger"
              size="small"
              type="border"
              icon="highlight_off"
              v-on:click.once="removeRol(role)"
              data-cy="remove-permission"
            />
          </vs-list-item>
        </div>
        <div v-show="loading">
          <b-skeleton animation="fade" width="70%"/>
          <b-skeleton animation="fade" width="80%"/>
          <b-skeleton animation="fade" width="60%"/>
          <b-skeleton animation="fade" width="85%"/>
          <b-skeleton animation="fade" width="70%"/>
        </div>
      </vs-list>
    </div>
    <div class="w-100 p-4 d-flex justify-end">
      <vs-button
          color="primary"
          type="border"
          @click="save"
          data-cy="apply"
        >
          Aplicar
          <span v-show="writing" class="spinner-border spinner-border-sm text-white" />
        </vs-button>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';

import { getRoles, modifyUserRoles } from '@/febos/servicios/api/usuarios.api';

export default {
  mixins: [],
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      searchInVacantRoles: '',
      rolesList: {},
      loading: false,
      writing: false
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    filteredAvailableRoles() {
      if (this.searchInVacantRoles !== '') {
        return Object.values(this.rolesList)
          .filter(
            (rol) => rol.nombre.toLowerCase().indexOf(this.searchInVacantRoles.toLowerCase()) > -1
          );
      }
      return this.rolesList;
    }
  },
  methods: {
    async loadRolesList() {
      this.loading = true;
      const response = await getRoles({
        userId: this.user.id
      });
      const list = response.data.roles.reduce((accumulator, role) => ({
        ...accumulator,
        [role.rolId]: { ...role },
      }), {});
      this.rolesList = list;
      this.loading = false;
    },
    addRol(role) {
      this.rolesList[role.rolId].asignado = 'si';
    },
    removeRol(role) {
      this.rolesList[role.rolId].asignado = 'no';
    },
    async save() {
      this.writing = true;
      const assignedRoles = this.getAssignedRoles();
      await modifyUserRoles({ assignedRoles, userId: this.user.id });
      this.writing = false;
      this.$emit('close-action');
    },
    getAssignedRoles() {
      return Object.values(this.rolesList)
        .filter((role) => role.asignado === 'si')
        .map((role) => role.rolId).join();
    },
  },
  mounted() {
    this.loading = false;
    this.writing = false;
    this.loadRolesList();
  }
};
</script>
<style scoped>

.box-users {
  height: 500px;
  overflow-y: auto;
}
.con-vs-popup .vs-popup {
  width: 70% !important;
}
.exists {
  color: #671e85;
  background: #671e852b;
  border-radius: 4px;
  margin-top: 2px;
}
</style>
